export const megaminxLLSVG = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="360px" height="343px" viewBox="0 0 360 343" version="1.1">
  <title>Megaminx LL</title>
  <defs>
    <g id="bogus">
        <rect x="-10" y="-10" width="1" height="1" stroke="black" stroke-width="0.04px" />
    </g>
  </defs>
  <g fill="none" fill-rule="nonzero" stroke="#000">
    <g style="stroke: black; stroke-width: 6; stroke-linecap: butt; stroke-linejoin: round;">
      <path id="CENTERS-l0-o0" style="fill: white;" d="M 179.5 143.480469 L 137.082031 174.296875 L 153.285156 224.164062 L 205.714844 224.164062 L 221.917969 174.296875 Z M 179.5 143.480469 "/>  />

      <path id="CORNERS-l6-o0" style="fill: white;" d="M 140.175781 92.605469 L 179.5 143.480469 L 218.824219 92.605469 L 179.5 64.035156 Z M 140.175781 92.605469 "/>  />
      <path id="CORNERS-l6-o1" style="fill: yellow;" d="M 125.15625 46.378906 L 140.175781 92.605469 L 179.5 64.035156 L 179.5 6.894531 Z M 125.15625 46.378906 "/> />
      <path id="CORNERS-l6-o2" style="fill: rgb(34, 102, 255);" d="M 179.5 64.035156 L 218.824219 92.605469 L 233.84375 46.378906 L 179.5 6.894531 Z M 179.5 64.035156 "/>  />

      <path id="EDGES-l26-o0" style="fill: white;" d="M 100.851562 121.175781 L 137.082031 174.296875 L 179.5 143.480469 L 140.175781 92.605469 Z M 100.851562 121.175781 "/> />
      <path id="EDGES-l26-o1" style="fill: yellow;" d="M 61.527344 92.605469 L 100.851562 121.175781 L 140.175781 92.605469 L 125.15625 46.378906 Z M 61.527344 92.605469 "/> />

      <path id="CORNERS-l1-o0" style="fill: white;" d="M 76.546875 195.976562 L 137.082031 174.296875 L 100.851562 121.175781 L 61.527344 149.75 Z M 76.546875 195.976562 "/> />
      <path id="CORNERS-l1-o1" style="fill: purple;" d="M 27.9375 195.976562 L 76.546875 195.976562 L 61.527344 149.75 L 7.179688 132.089844 Z M 27.9375 195.976562 "/>  />
      <path id="CORNERS-l1-o2" style="fill: yellow;" d="M 61.527344 149.75 L 100.851562 121.175781 L 61.527344 92.605469 L 7.179688 132.089844 Z M 61.527344 149.75 "/> />

      <path id="EDGES-l1-o0" style="fill: white;" d="M 91.566406 242.207031 L 153.285156 224.164062 L 137.082031 174.296875 L 76.546875 195.976562 Z M 91.566406 242.207031 "/> />
      <path id="EDGES-l1-o1" style="fill: purple;" d="M 52.242188 270.777344 L 91.566406 242.207031 L 76.546875 195.976562 L 27.9375 195.976562 Z M 52.242188 270.777344 "/> />

      <path id="CORNERS-l0-o0" style="fill: white;" d="M 155.195312 288.4375 L 153.285156 224.164062 L 91.566406 242.207031 L 106.585938 288.4375 Z M 155.195312 288.4375 "/> />
      <path id="CORNERS-l0-o1" style="fill: limegreen;" d="M 140.175781 334.664062 L 155.195312 288.4375 L 106.585938 288.4375 L 73 334.664062 Z M 140.175781 334.664062 "/>  />
      <path id="CORNERS-l0-o2" style="fill: purple;" d="M 106.585938 288.4375 L 91.566406 242.207031 L 52.242188 270.777344 L 73 334.664062 Z M 106.585938 288.4375 "/>  />

      <path id="EDGES-l0-o0" style="fill: white;" d="M 203.804688 288.4375 L 205.714844 224.164062 L 153.285156 224.164062 L 155.195312 288.4375 Z M 203.804688 288.4375 "/>  />
      <path id="EDGES-l0-o1" style="fill: limegreen;" d="M 218.824219 334.664062 L 203.804688 288.4375 L 155.195312 288.4375 L 140.175781 334.664062 Z M 218.824219 334.664062 "/>  />

      <path id="CORNERS-l2-o0" style="fill: white;" d="M 267.433594 242.207031 L 205.714844 224.164062 L 203.804688 288.4375 L 252.414062 288.4375 Z M 267.433594 242.207031 "/>  />
      <path id="CORNERS-l2-o1" style="fill: red;" d="M 306.757812 270.777344 L 267.433594 242.207031 L 252.414062 288.4375 L 286 334.664062 Z M 306.757812 270.777344 "/> />
      <path id="CORNERS-l2-o2" style="fill: limegreen;" d="M 252.414062 288.4375 L 203.804688 288.4375 L 218.824219 334.664062 L 286 334.664062 Z M 252.414062 288.4375 "/> />

      <path id="EDGES-l7-o0" style="fill: white;" d="M 282.453125 195.976562 L 221.917969 174.296875 L 205.714844 224.164062 L 267.433594 242.207031 Z M 282.453125 195.976562 "/>  />
      <path id="EDGES-l7-o1" style="fill: red;" d="M 331.0625 195.976562 L 282.453125 195.976562 L 267.433594 242.207031 L 306.757812 270.777344 Z M 331.0625 195.976562 "/>  />

      <path id="CORNERS-l7-o0" style="fill: white;" d="M 258.148438 121.175781 L 221.917969 174.296875 L 282.453125 195.976562 L 297.472656 149.75 Z M 258.148438 121.175781 "/>  />
      <path id="CORNERS-l7-o1" style="fill: rgb(34, 102, 255);" d="M 297.472656 92.605469 L 258.148438 121.175781 L 297.472656 149.75 L 351.820312 132.089844 Z M 297.472656 92.605469 "/>  />
      <path id="CORNERS-l7-o2" style="fill: red;" d="M 297.472656 149.75 L 282.453125 195.976562 L 331.0625 195.976562 L 351.820312 132.089844 Z M 297.472656 149.75 "/>  />

      <path id="EDGES-l6-o0" style="fill: white;" d="M 218.824219 92.605469 L 179.5 143.480469 L 221.917969 174.296875 L 258.148438 121.175781 Z M 218.824219 92.605469 "/> />
      <path id="EDGES-l6-o1" style="fill: rgb(34, 102, 255);" d="M 233.84375 46.378906 L 218.824219 92.605469 L 258.148438 121.175781 L 297.472656 92.605469 Z M 233.84375 46.378906 "/>  />
    </g>
    <g opacity="0">
      <g><title>U</title>
      <polygon id="CENTERS-l0-o1" href="#bogus" style="fill: white"/>
      <polygon id="CENTERS-l0-o2" href="#bogus" style="fill: white"/>
      <polygon id="CENTERS-l0-o3" href="#bogus" style="fill: white"/>
      <polygon id="CENTERS-l0-o4" href="#bogus" style="fill: white"/>
      </g><g><title>F</title>
      <polygon id="EDGES-l8-o0" href="#bogus" style="fill: limegreen"/>
      <polygon id="EDGES-l2-o0" href="#bogus" style="fill: limegreen"/>
      <polygon id="CENTERS-l2-o0" href="#bogus" style="fill: limegreen"/>
      <polygon id="CENTERS-l2-o1" href="#bogus" style="fill: limegreen"/>
      <polygon id="CENTERS-l2-o2" href="#bogus" style="fill: limegreen"/>
      <polygon id="CENTERS-l2-o3" href="#bogus" style="fill: limegreen"/>
      <polygon id="CENTERS-l2-o4" href="#bogus" style="fill: limegreen"/>
      <polygon id="EDGES-l27-o1" href="#bogus" style="fill: limegreen"/>
      <polygon id="CORNERS-l19-o1" href="#bogus" style="fill: limegreen"/>
      <polygon id="CORNERS-l8-o0" href="#bogus" style="fill: limegreen"/>
      <polygon id="EDGES-l3-o0" href="#bogus" style="fill: limegreen"/>
      <polygon id="CORNERS-l3-o2" href="#bogus" style="fill: limegreen"/>
      </g><g><title>L</title>
      <polygon id="EDGES-l5-o1" href="#bogus" style="fill: #660099"/>
      <polygon id="EDGES-l8-o1" href="#bogus" style="fill: #660099"/>
      <polygon id="CENTERS-l3-o0" href="#bogus" style="fill: #660099"/>
      <polygon id="CENTERS-l3-o1" href="#bogus" style="fill: #660099"/>
      <polygon id="CENTERS-l3-o2" href="#bogus" style="fill: #660099"/>
      <polygon id="CENTERS-l3-o3" href="#bogus" style="fill: #660099"/>
      <polygon id="CENTERS-l3-o4" href="#bogus" style="fill: #660099"/>
      <polygon id="EDGES-l4-o1" href="#bogus" style="fill: #660099"/>
      <polygon id="CORNERS-l3-o1" href="#bogus" style="fill: #660099"/>
      <polygon id="CORNERS-l4-o0" href="#bogus" style="fill: #660099"/>
      <polygon id="EDGES-l10-o1" href="#bogus" style="fill: #660099"/>
      <polygon id="CORNERS-l5-o2" href="#bogus" style="fill: #660099"/>
      </g><g><title>BL</title>
      <polygon id="EDGES-l14-o1" href="#bogus" style="fill: yellow"/>
      <polygon id="EDGES-l5-o0" href="#bogus" style="fill: yellow"/>
      <polygon id="CENTERS-l4-o0" href="#bogus" style="fill: yellow"/>
      <polygon id="CENTERS-l4-o1" href="#bogus" style="fill: yellow"/>
      <polygon id="CENTERS-l4-o2" href="#bogus" style="fill: yellow"/>
      <polygon id="CENTERS-l4-o3" href="#bogus" style="fill: yellow"/>
      <polygon id="CENTERS-l4-o4" href="#bogus" style="fill: yellow"/>
      <polygon id="EDGES-l12-o1" href="#bogus" style="fill: yellow"/>
      <polygon id="CORNERS-l5-o1" href="#bogus" style="fill: yellow"/>
      <polygon id="CORNERS-l10-o0" href="#bogus" style="fill: yellow"/>
      <polygon id="EDGES-l16-o0" href="#bogus" style="fill: yellow"/>
      <polygon id="CORNERS-l11-o2" href="#bogus" style="fill: yellow"/>
      </g><g><title>BR</title>
      <polygon id="EDGES-l21-o0" href="#bogus" style="fill: rgb(34, 102, 255)"/>
      <polygon id="EDGES-l14-o0" href="#bogus" style="fill: rgb(34, 102, 255)"/>
      <polygon id="CENTERS-l5-o0" href="#bogus" style="fill: rgb(34, 102, 255)"/>
      <polygon id="CENTERS-l5-o1" href="#bogus" style="fill: rgb(34, 102, 255)"/>
      <polygon id="CENTERS-l5-o2" href="#bogus" style="fill: rgb(34, 102, 255)"/>
      <polygon id="CENTERS-l5-o3" href="#bogus" style="fill: rgb(34, 102, 255)"/>
      <polygon id="CENTERS-l5-o4" href="#bogus" style="fill: rgb(34, 102, 255)"/>
      <polygon id="EDGES-l18-o1" href="#bogus" style="fill: rgb(34, 102, 255)"/>
      <polygon id="CORNERS-l11-o1" href="#bogus" style="fill: rgb(34, 102, 255)"/>
      <polygon id="CORNERS-l13-o0" href="#bogus" style="fill: rgb(34, 102, 255)"/>
      <polygon id="EDGES-l28-o1" href="#bogus" style="fill: rgb(34, 102, 255)"/>
      <polygon id="CORNERS-l12-o2" href="#bogus" style="fill: rgb(34, 102, 255)"/>
      </g><g><title>R</title>
      <polygon id="CORNERS-l19-o2" href="#bogus" style="fill: red"/>
      <polygon id="EDGES-l19-o1" href="#bogus" style="fill: red"/>
      <polygon id="CENTERS-l1-o0" href="#bogus" style="fill: red"/>
      <polygon id="CENTERS-l1-o1" href="#bogus" style="fill: red"/>
      <polygon id="CENTERS-l1-o2" href="#bogus" style="fill: red"/>
      <polygon id="CENTERS-l1-o3" href="#bogus" style="fill: red"/>
      <polygon id="CENTERS-l1-o4" href="#bogus" style="fill: red"/>
      <polygon id="EDGES-l2-o1" href="#bogus" style="fill: red"/>
      <polygon id="EDGES-l21-o1" href="#bogus" style="fill: red"/>
      <polygon id="CORNERS-l12-o1" href="#bogus" style="fill: red"/>
      <polygon id="EDGES-l15-o1" href="#bogus" style="fill: red"/>
      <polygon id="CORNERS-l14-o0" href="#bogus" style="fill: red"/>
      </g><g><title>C</title>
      <polygon id="CORNERS-l8-o1" href="#bogus" style="fill: #ffffd0"/>
      <polygon id="EDGES-l9-o1" href="#bogus" style="fill: #ffffd0"/>
      <polygon id="CORNERS-l19-o0" href="#bogus" style="fill: #ffffd0"/>
      <polygon id="EDGES-l19-o0" href="#bogus" style="fill: #ffffd0"/>
      <polygon id="CENTERS-l6-o0" href="#bogus" style="fill: #ffffd0"/>
      <polygon id="CENTERS-l6-o1" href="#bogus" style="fill: #ffffd0"/>
      <polygon id="CENTERS-l6-o2" href="#bogus" style="fill: #ffffd0"/>
      <polygon id="CENTERS-l6-o3" href="#bogus" style="fill: #ffffd0"/>
      <polygon id="CENTERS-l6-o4" href="#bogus" style="fill: #ffffd0"/>
      <polygon id="EDGES-l27-o0" href="#bogus" style="fill: #ffffd0"/>
      <polygon id="EDGES-l29-o1" href="#bogus" style="fill: #ffffd0"/>
      <polygon id="CORNERS-l14-o2" href="#bogus" style="fill: #ffffd0"/>
      <polygon id="CORNERS-l16-o1" href="#bogus" style="fill: #ffffd0"/>
      <polygon id="EDGES-l22-o0" href="#bogus" style="fill: #ffffd0"/>
      <polygon id="CORNERS-l17-o2" href="#bogus" style="fill: #ffffd0"/>
      </g><g><title>A</title>
      <polygon id="CORNERS-l4-o1" href="#bogus" style="fill: #3399ff"/>
      <polygon id="EDGES-l13-o1" href="#bogus" style="fill: #3399ff"/>
      <polygon id="CORNERS-l3-o0" href="#bogus" style="fill: #3399ff"/>
      <polygon id="EDGES-l3-o1" href="#bogus" style="fill: #3399ff"/>
      <polygon id="CENTERS-l7-o0" href="#bogus" style="fill: #3399ff"/>
      <polygon id="CENTERS-l7-o1" href="#bogus" style="fill: #3399ff"/>
      <polygon id="CENTERS-l7-o2" href="#bogus" style="fill: #3399ff"/>
      <polygon id="CENTERS-l7-o3" href="#bogus" style="fill: #3399ff"/>
      <polygon id="CENTERS-l7-o4" href="#bogus" style="fill: #3399ff"/>
      <polygon id="EDGES-l4-o0" href="#bogus" style="fill: #3399ff"/>
      <polygon id="EDGES-l9-o0" href="#bogus" style="fill: #3399ff"/>
      <polygon id="CORNERS-l8-o2" href="#bogus" style="fill: #3399ff"/>
      <polygon id="CORNERS-l17-o1" href="#bogus" style="fill: #3399ff"/>
      <polygon id="EDGES-l11-o0" href="#bogus" style="fill: #3399ff"/>
      <polygon id="CORNERS-l9-o2" href="#bogus" style="fill: #3399ff"/>
      </g><g><title>I</title>
      <polygon id="CORNERS-l5-o0" href="#bogus" style="fill: #ff6633"/>
      <polygon id="EDGES-l12-o0" href="#bogus" style="fill: #ff6633"/>
      <polygon id="CORNERS-l4-o2" href="#bogus" style="fill: #ff6633"/>
      <polygon id="EDGES-l13-o0" href="#bogus" style="fill: #ff6633"/>
      <polygon id="CENTERS-l8-o0" href="#bogus" style="fill: #ff6633"/>
      <polygon id="CENTERS-l8-o1" href="#bogus" style="fill: #ff6633"/>
      <polygon id="CENTERS-l8-o2" href="#bogus" style="fill: #ff6633"/>
      <polygon id="CENTERS-l8-o3" href="#bogus" style="fill: #ff6633"/>
      <polygon id="CENTERS-l8-o4" href="#bogus" style="fill: #ff6633"/>
      <polygon id="EDGES-l10-o0" href="#bogus" style="fill: #ff6633"/>
      <polygon id="EDGES-l23-o0" href="#bogus" style="fill: #ff6633"/>
      <polygon id="CORNERS-l9-o1" href="#bogus" style="fill: #ff6633"/>
      <polygon id="CORNERS-l18-o2" href="#bogus" style="fill: #ff6633"/>
      <polygon id="EDGES-l17-o0" href="#bogus" style="fill: #ff6633"/>
      <polygon id="CORNERS-l10-o1" href="#bogus" style="fill: #ff6633"/>
      </g><g><title>BF</title>
      <polygon id="CORNERS-l11-o0" href="#bogus" style="fill: #99ff00"/>
      <polygon id="EDGES-l18-o0" href="#bogus" style="fill: #99ff00"/>
      <polygon id="CORNERS-l10-o2" href="#bogus" style="fill: #99ff00"/>
      <polygon id="EDGES-l17-o1" href="#bogus" style="fill: #99ff00"/>
      <polygon id="CENTERS-l10-o0" href="#bogus" style="fill: #99ff00"/>
      <polygon id="CENTERS-l10-o1" href="#bogus" style="fill: #99ff00"/>
      <polygon id="CENTERS-l10-o2" href="#bogus" style="fill: #99ff00"/>
      <polygon id="CENTERS-l10-o3" href="#bogus" style="fill: #99ff00"/>
      <polygon id="CENTERS-l10-o4" href="#bogus" style="fill: #99ff00"/>
      <polygon id="EDGES-l16-o1" href="#bogus" style="fill: #99ff00"/>
      <polygon id="EDGES-l20-o0" href="#bogus" style="fill: #99ff00"/>
      <polygon id="CORNERS-l18-o1" href="#bogus" style="fill: #99ff00"/>
      <polygon id="CORNERS-l15-o2" href="#bogus" style="fill: #99ff00"/>
      <polygon id="EDGES-l24-o1" href="#bogus" style="fill: #99ff00"/>
      <polygon id="CORNERS-l13-o1" href="#bogus" style="fill: #99ff00"/>
      </g><g><title>E</title>
      <polygon id="CORNERS-l12-o0" href="#bogus" style="fill: #ff66cc"/>
      <polygon id="EDGES-l15-o0" href="#bogus" style="fill: #ff66cc"/>
      <polygon id="CORNERS-l13-o2" href="#bogus" style="fill: #ff66cc"/>
      <polygon id="EDGES-l24-o0" href="#bogus" style="fill: #ff66cc"/>
      <polygon id="CENTERS-l9-o0" href="#bogus" style="fill: #ff66cc"/>
      <polygon id="CENTERS-l9-o1" href="#bogus" style="fill: #ff66cc"/>
      <polygon id="CENTERS-l9-o2" href="#bogus" style="fill: #ff66cc"/>
      <polygon id="CENTERS-l9-o3" href="#bogus" style="fill: #ff66cc"/>
      <polygon id="CENTERS-l9-o4" href="#bogus" style="fill: #ff66cc"/>
      <polygon id="EDGES-l28-o0" href="#bogus" style="fill: #ff66cc"/>
      <polygon id="EDGES-l25-o0" href="#bogus" style="fill: #ff66cc"/>
      <polygon id="CORNERS-l15-o1" href="#bogus" style="fill: #ff66cc"/>
      <polygon id="CORNERS-l16-o2" href="#bogus" style="fill: #ff66cc"/>
      <polygon id="EDGES-l29-o0" href="#bogus" style="fill: #ff66cc"/>
      <polygon id="CORNERS-l14-o1" href="#bogus" style="fill: #ff66cc"/>
      </g><g><title>D</title>
      <polygon id="CORNERS-l17-o0" href="#bogus" style="fill: #999999"/>
      <polygon id="EDGES-l11-o1" href="#bogus" style="fill: #999999"/>
      <polygon id="CORNERS-l16-o0" href="#bogus" style="fill: #999999"/>
      <polygon id="EDGES-l25-o1" href="#bogus" style="fill: #999999"/>
      <polygon id="CENTERS-l11-o0" href="#bogus" style="fill: #999999"/>
      <polygon id="CENTERS-l11-o1" href="#bogus" style="fill: #999999"/>
      <polygon id="CENTERS-l11-o2" href="#bogus" style="fill: #999999"/>
      <polygon id="CENTERS-l11-o3" href="#bogus" style="fill: #999999"/>
      <polygon id="CENTERS-l11-o4" href="#bogus" style="fill: #999999"/>
      <polygon id="EDGES-l22-o1" href="#bogus" style="fill: #999999"/>
      <polygon id="EDGES-l20-o1" href="#bogus" style="fill: #999999"/>
      <polygon id="CORNERS-l15-o0" href="#bogus" style="fill: #999999"/>
      <polygon id="CORNERS-l18-o0" href="#bogus" style="fill: #999999"/>
      <polygon id="EDGES-l23-o1" href="#bogus" style="fill: #999999"/>
      <polygon id="CORNERS-l9-o0" href="#bogus" style="fill: #999999"/>
      </g>
    </g>
  </g>
</svg>
`;
